import '../../datatables/tags-sort';
import sweetAlert from 'sweetalert';
import SidePanel from './sidepanel';
import displayDatatablesPagination from '../shared/datatables_pagination';
import { withSaveState } from '../shared/datatables_state';
import {
  overridePaginationClasses,
  customizeDOMPaginationClasses
} from '../../datatables/customization-v2';
import {
  setup as tableSetup,
  setupPaginationOnDOM,
  customizePageLength,
  evaluateSelectedRows,
  defaultTableOptions
} from '../../datatables/table-setup';

export const LISTS_TABLE_SELECTOR = '.event-parts-table';

const EventPartsTable = {
  start() {
    const $table = $(`${LISTS_TABLE_SELECTOR}:not(.dataTable)`);
    if (!$table.length) {
      return;
    }
    this.setupDataTable($table);
    this.watchDelete($table.DataTable());
    this.watchBulkEdit($table.DataTable());
    this.watchSelectionStart($table.DataTable());
  },

  watchDelete(table) {
    $('.js-delete-items').on('click', (event) => {
      const $button = $(event.currentTarget);
      const deleteUrl = $button.data('deleteUrl');
      const alertText = $button.data('alertText');
      sweetAlert({
        title: 'Warning!',
        text: alertText,
        icon: 'warning',
        dangerMode: true,
        buttons: ['Cancel', 'Delete']
      }).then((confirmed) => {
        if (!confirmed) return;
        const ids = $.map(
          table.rows({ selected: true }).nodes(),
          (row) => $(row).data('id')
        );
        $.ajax({ url: deleteUrl, method: 'DELETE', data: { event_part_ids: ids } })
          .done(() => { window.location.reload(); })
          .fail(() => {
            sweetAlert({ title: 'Error', text: 'The activities could not be deleted.', icon: 'error' });
          });
      });
    });
  },

  watchBulkEdit(table) {
    $('.js-bulk-edit-items').on('click', (event) => {
      const $button = $(event.currentTarget);
      const editUrl = $button.data('editUrl');
      const ids = $.map(
        table.rows({ selected: true }).nodes(),
        (row) => $(row).data('id')
      );
      SidePanel.show();
      SidePanel.load(editUrl, { event_part_ids: ids, kind: 'groups' });
    });
    $(document).on('change', '[name="group_action"]', function () {
      const isSet = this.value === 'set';
      const isRemove = this.value === 'remove';
      const hasLeadSelected = (isSet || isRemove) && table.rows({ selected: true }).nodes().toArray()
        .some((row) => $(row).data('activityType') === 'lead');
      $('#js-group-dropdown').toggleClass('is-hidden', !isSet);
      $('#js-set-group-lead-notice').toggleClass('is-hidden', !(isSet && hasLeadSelected));
      $('#js-remove-group-lead-notice').toggleClass('is-hidden', !(isRemove && hasLeadSelected));
    });
    SidePanel.onUpdate(() => {
      SidePanel.element().find('.js-bulk-edit-form').on('ajax:error', (event) => {
        const data = event.detail?.[0];
        sweetAlert({
          title: 'Error',
          text: data?.error || 'The activities could not be updated.',
          icon: 'error'
        });
      });
    });
  },

  watchSelectionStart(table) {
    table.on('select', () => {
      if (table.rows({ selected: true }).count() === 1 && SidePanel.element().hasClass('is-visible')) {
        SidePanel.reset();
      }
    });
  },

  tearDown() {
    $(`${LISTS_TABLE_SELECTOR}.dataTable`).DataTable().destroy();
  },

  setupDataTable($table) {
    overridePaginationClasses();
    const $checkAllCheckbox = $('#checkall');
    let table;
    const tagsColIndex = $table.find('th.js-tags-col').index();
    const columnDefs = [
      { targets: [0], orderable: false, width: '7%' },
      { targets: [1], orderable: true, width: '7%' },
      { targets: [2], searchable: true, width: '20%' },
      { targets: [-1], orderable: false, width: '9%' },
      { targets: '_all', searchable: false }
    ];
    if (tagsColIndex >= 0) columnDefs.push({ targets: [tagsColIndex], type: 'tags', width: '15%' });

    const selectedTagIds = new Set();
    $.fn.dataTable.ext.search.push((settings, _data, index) => {
      if (settings.nTable !== $table[0]) return true;
      if (selectedTagIds.size === 0) return true;
      const rowNode = table.row(index).node();
      const rawIds = ($(rowNode).data('tag-ids') || '').toString();
      const rowTagIds = rawIds.split(',').filter(Boolean);
      return rowTagIds.some(id => selectedTagIds.has(id));
    });

    // Persist the tag filter selection via DataTables' save/load state channel.
    // Bind before .DataTable() so the initial stateLoadParams event during
    // init is caught and we can restore checkboxes before the first draw.
    $table.on('stateSaveParams.dt', (e, settings, data) => {
      data.selectedTagIds = Array.from(selectedTagIds);
    });
    $table.on('stateLoadParams.dt', (e, settings, data) => {
      if (!Array.isArray(data.selectedTagIds) || data.selectedTagIds.length === 0) return;
      selectedTagIds.clear();
      data.selectedTagIds.forEach(id => selectedTagIds.add(String(id)));
      selectedTagIds.forEach(id => {
        $(`.js-tag-filter-check[data-tag-id="${id}"]`).prop('checked', true);
      });
      this._updateTagFilterUI(selectedTagIds.size);
    });

    const tableOptions = {
      ...defaultTableOptions,
      order: [[1, 'asc']],
      dom: 'rtp',
      select: {
        style: 'multi',
        selector: 'label.js-checkbox-for-row',
        className: 'is-selected'
      },
      columnDefs,
      drawCallback() {
        customizePageLength(this);
        customizeDOMPaginationClasses();
        evaluateSelectedRows(table, $checkAllCheckbox);
        displayDatatablesPagination(this);
      },
      initComplete: () => {
        setupPaginationOnDOM();
        this.watchTagFilter(table, selectedTagIds);
      },
      language: {
        ...defaultTableOptions.language,
        zeroRecords:
          '<span class="alert alert--info">Sorry, no matching Event Activities were found</span>',
        emptyTable: '<span class="alert alert--info">No Event Activities available</span>'
      }
    };
    const tableOptionsWithSaveState = withSaveState($table, tableOptions);
    table = $table.DataTable(tableOptionsWithSaveState);
    tableSetup(table);
  },

  watchTagFilter(table, selectedTagIds) {
    $('.js-tag-filter-dropdown .dropdown__list').on('click', (e) => {
      e.stopPropagation();
    });

    $('.js-tag-filter-check').on('change', (e) => {
      const tagId = String($(e.currentTarget).data('tag-id'));
      if (e.currentTarget.checked) {
        selectedTagIds.add(tagId);
      } else {
        selectedTagIds.delete(tagId);
      }
      this._updateTagFilterUI(selectedTagIds.size);
      table.state.save();
      table.draw();
    });

    $('.js-tag-filter-clear').on('click', (e) => {
      e.preventDefault();
      selectedTagIds.clear();
      $('.js-tag-filter-check').prop('checked', false);
      this._updateTagFilterUI(0);
      table.state.save();
      table.draw();
    });
  },

  _updateTagFilterUI(count) {
    $('.js-tag-filter-counter').text(count).toggleClass('is-hidden', count === 0);
    $('.js-tag-filter-clear').toggleClass('is-hidden', count === 0);
  }
};

export default EventPartsTable;
